import { mergeTemplate } from './base-template';

export const zahnarztTemplate = mergeTemplate({
  name: 'Zahnarztpraxis',
  icon: '🦷',
  settings: {
    primaryColor: '#0891b2',
    accentColor: '#14b8a6',
    fontStack: 'dmsans',
    stylePreset: 'swiss',
    pageAngebot: {
      heroTitle: 'Zahnmedizinische Leistungen',
      heroSubtitle: 'Moderne Zahnmedizin für Ihr schönstes Lächeln',
      packages: [
        { name: 'Prophylaxe', price: 'ab CHF 150', description: 'Professionelle Zahnreinigung und Vorsorge', features: 'Dentalhygiene, Zahnsteinentfernung, Polieren, Fluoridierung, Beratung', highlighted: false },
        { name: 'Ästhetische Zahnmedizin', price: 'auf Anfrage', description: 'Für ein strahlendes Lächeln', features: 'Bleaching, Veneers, Zahnkorrektur, Composite-Füllungen, Smile Design', highlighted: true },
        { name: 'Implantologie', price: "ab CHF 3'500", description: 'Hochwertiger Zahnersatz', features: '3D-Planung, Implantation, Knochenaufbau, Prothetik, Nachsorge', highlighted: false },
      ],
      ctaTitle: 'Für ein gesundes Lächeln',
      ctaText: 'Vereinbaren Sie Ihren Termin — wir beraten Sie gerne und unverbindlich.',
      ctaButtonText: 'Termin vereinbaren',
    },
    pageMethoden: {
      heroTitle: 'Unser Behandlungskonzept',
      heroSubtitle: 'Sanft, modern, patientenorientiert',
      introText: 'Wir setzen auf minimalinvasive Verfahren, modernste Technik und eine einfühlsame Behandlung — auch bei Angstpatienten.',
      steps: [
        { title: 'Befundaufnahme', description: 'Gründliche Untersuchung mit digitaler Diagnostik und 3D-Röntgen' },
        { title: 'Behandlungsplan', description: 'Transparente Planung aller Schritte und Kosten' },
        { title: 'Behandlung', description: 'Schonende Durchführung mit modernster Technik' },
        { title: 'Nachsorge', description: 'Kontrollen, Prophylaxe und langfristige Betreuung' },
      ],
      tools: [
        { name: '3D-Röntgen (DVT)', description: 'Präzise Diagnostik für Implantate und komplexe Fälle' },
        { name: 'Intraorale Kamera', description: 'Live-Bilder für transparente Beratung' },
        { name: 'CAD/CAM-System', description: 'Digitale Zahnersatzherstellung in einer Sitzung' },
      ],
      philosophyTitle: 'Unsere Behandlungsphilosophie',
      philosophyText: 'Zahnmedizin soll nicht wehtun. Wir behandeln sanft, erklären verständlich und nehmen uns Zeit für Sie.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Praxis-Team',
      heroSubtitle: 'Erfahrung und Einfühlungsvermögen',
      introText: 'Unser Team aus Zahnärztinnen, Zahnärzten und Dentalhygienikerinnen betreut Sie kompetent und herzlich.',
      imageUrl: '',
      timeline: [
        { year: '2008', text: 'Gründung der Praxis' },
        { year: '2016', text: 'Erweiterung um Implantologie' },
        { year: '2022', text: 'Modernisierung mit digitalem Workflow' },
      ],
      values: [
        { title: 'Sanftheit', description: 'Schmerzarme Behandlung für alle — auch Angstpatienten' },
        { title: 'Transparenz', description: 'Klare Kostenvoranschläge und verständliche Erklärungen' },
        { title: 'Innovation', description: 'Modernste Technik für beste Ergebnisse' },
      ],
      certifications: 'SSO, Implant Foundation DGI, ZZMK-Fortbildungen',
    },
  },
  components: {
    header: {
      companyName: 'Zahnpraxis Muster',
      logoText: 'ZM',
      navItems: ['Leistungen', 'Methoden', 'Team', 'Kontakt'],
      ctaText: 'Termin buchen',
    },
    hero: {
      title: 'Gesunde Zähne. Entspannt.',
      subtitle: 'Moderne Zahnmedizin mit persönlicher Betreuung.',
      primaryBtn: 'Termin buchen',
      secondaryBtn: 'Behandlungen',
    },
    trust: {
      items: [
        { value: 'Modern', label: 'Ausstattung' },
        { value: 'Einfühlsam', label: 'Behandlung' },
        { value: 'Digital', label: 'Röntgen' },
        { value: 'Notfall', label: 'Service' },
      ],
    },
    services: {
      title: 'Behandlungen',
      subtitle: 'Vorsorge und Therapie.',
      items: [
        {
          icon: '🔍',
          title: 'Prophylaxe',
          text: 'Kontrollen, Dentalhygiene, Früherkennung.',
        },
        {
          icon: '🦷',
          title: 'Zahnerhalt',
          text: 'Füllungen, Wurzelbehandlungen, Kronen.',
        },
        {
          icon: '✨',
          title: 'Ästhetik',
          text: 'Bleaching, Veneers, unsichtbare Korrekturen.',
        },
      ],
    },
    team: {
      title: 'Ihr Team',
      subtitle: 'Kompetent und einfühlsam.',
      members: [
        {
          name: 'Dr. med. dent. Muster',
          role: 'Zahnarzt',
          image: '',
          bio: 'Allgemeine Zahnmedizin, Implantologie.',
        },
        {
          name: 'Anna Beispiel',
          role: 'Dentalhygienikerin',
          image: '',
          bio: 'Prophylaxe und Beratung.',
        },
      ],
    },
    testimonials: {
      title: 'Patientenstimmen',
      items: [
        {
          quote:
            'Endlich ein Zahnarzt, bei dem ich mich entspannen kann.',
          author: 'Patient',
          role: '',
        },
        {
          quote: 'Sehr einfühlsames Team — auch meine Kinder gehen jetzt gerne zum Zahnarzt.',
          author: 'Sabine M.',
          role: 'Mutter von zwei Kindern',
        },
        {
          quote: 'Die Dentalhygiene war gründlich und trotzdem schmerzfrei. Sehr empfehlenswert.',
          author: 'Thomas R.',
          role: 'Patient seit 2019',
        },
        {
          quote: 'Transparente Kostenvoranschläge und keine Überraschungen. So muss es sein.',
          author: 'Claudia W.',
          role: 'Privatpatientin',
        },
        {
          quote: 'Ich hatte grosse Angst vor der Implantation, aber das Team hat mich hervorragend betreut.',
          author: 'Peter K.',
          role: 'Implantat-Patient',
        },
        {
          quote: 'Moderne Praxis mit warmherziger Atmosphäre. Fühle mich seit Jahren bestens aufgehoben.',
          author: 'Monika L.',
          role: 'Patientin seit 2015',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Nehmen Sie neue Patienten auf?',
          answer: 'Ja – kontaktieren Sie uns für einen Ersttermin.',
        },
        {
          question: 'Was kostet eine professionelle Zahnreinigung?',
          answer: 'Eine Dentalhygiene-Sitzung kostet ab CHF 150, je nach Aufwand und Dauer. Einige Zusatzversicherungen beteiligen sich an den Kosten.',
        },
        {
          question: 'Behandeln Sie auch Angstpatienten?',
          answer: 'Ja, wir sind auf einfühlsame Behandlung spezialisiert. Wir nehmen uns extra Zeit, erklären jeden Schritt und bieten bei Bedarf Sedierung an.',
        },
        {
          question: 'Wie lange dauert eine Implantat-Behandlung?',
          answer: 'Von der Planung bis zum fertigen Zahnersatz dauert es in der Regel 3 bis 6 Monate, je nach individuellem Heilungsverlauf und ob ein Knochenaufbau nötig ist.',
        },
      ],
    },
    cta: {
      title: 'Termin buchen',
      subtitle: 'Online oder telefonisch – wir freuen uns auf Sie.',
      email: 'praxis@example.ch',
    },
    footer: {
      companyName: 'Zahnpraxis Muster',
      tagline: 'Ihr Zahnarzt in der Region.',
      email: 'praxis@example.ch',
    },
  },
});
